// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GfU9","questions":"styles_questions__2W-c2","footer":"styles_footer__3O4el"};